import api from '@common/api';
import create from 'zustand';

interface WaitlistViewModelProps {
  code?: string;
  email?: string;
  position?: number;
}
interface WaitlistViewModelActions {
  joinWaitlist: (
    email: string,
    referralCode?: string,
  ) => Promise<{ success: boolean; error?: string; code?: string; position?: number }>;
  checkStatusByCode: (
    code: string,
  ) => Promise<{ success: boolean; error?: string; code?: string; email?: string; position?: number }>;
  checkStatusByEmail: (
    email: string,
  ) => Promise<{ success: boolean; error?: string; code?: string; email?: string; position?: number }>;
  setCode: (code: string) => void;
  setPosition: (position: number) => void;
  setEmail: (email: string) => void;
}
export const useWaitlistViewModel = create<WaitlistViewModelProps & WaitlistViewModelActions>((set) => ({
  checkStatusByCode: async (code: string) => {
    try {
      const status = await api.waitlistGetPosition({ code });
      if (!status || !status.referral_code || !status.position || !status.email)
        return {
          error: 'Code not found',
          success: false,
        };
      set({ code: status.referral_code, email: status.email, position: status.position });
      return Promise.resolve({
        code: status.referral_code,
        email: status.email,
        position: status.position,
        success: true,
      });
    } catch (err) {
      return Promise.resolve({
        error: 'Invalid code',
        success: false,
      });
    }
  },
  checkStatusByEmail: async (email: string) => {
    try {
      const status = await api.waitlistLookupEmail({ email });
      if (!status || !status.referral_code || !status.position || !status.email)
        return {
          error: 'Email not found',
          success: false,
        };
      set({ code: status.referral_code, email: status.email, position: status.position });
      return Promise.resolve({
        code: status.referral_code,
        email: status.email,
        position: status.position,
        success: true,
      });
    } catch (err) {
      return Promise.resolve({
        error: 'Invalid email',
        success: false,
      });
    }
  },
  joinWaitlist: async (email: string, referrer_code?) => {
    try {
      const status = await api.waitlistAdd({ email, referrer_code });
      if (!status || !status.referral_code || !status.position)
        return {
          error: 'Something went wrong',
          success: false,
        };
      set({ code: status.referral_code, email, position: status.position });
      return Promise.resolve({
        code: status.referral_code,
        email: status.email,
        position: status.position,
        success: true,
      });
    } catch (err: any) {
      const isDuplicate = err.message === 'Email already exists';
      if (isDuplicate) {
        return Promise.resolve({
          error: err.message,
          success: false,
        });
      }
      return Promise.resolve({
        error: 'Something went wrong',
        success: false,
      });
    }
  },
  setCode: (code: string) => set({ code }),
  setEmail: (email: string) => set({ email }),
  setPosition: (position: number) => set({ position }),
}));
